import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "fs12 w100 fw600"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideUrl)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createVNode(_component_CopyButton, {
            linkUrl: _ctx.url,
            gtagCategory: `リンクコピーURL`,
            class: "fr"
          }, null, 8, ["linkUrl"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_3,
    (!_ctx.hideUrl)
      ? (_openBlock(), _createBlock(_component_TextfieldTag, {
          key: 1,
          style: {"height":"50px","min-width":"280px","max-width":"100%","margin-top":"10px"},
          class: _normalizeClass(`fl fs14 roundForm w100 pageLinkUrl${_ctx.index}`),
          value: _ctx.url,
          onClickTextfield: _ctx.clickTextfield
        }, null, 8, ["class", "value", "onClickTextfield"]))
      : _createCommentVNode("", true),
    _hoisted_4,
    _hoisted_5,
    (_ctx.url && !_ctx.hideQRcode)
      ? (_openBlock(), _createBlock(_component_VueQrcode, {
          key: 2,
          value: _ctx.url,
          options: { width: 200 },
          tag: "img"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}